/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Info/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Info({
  children,
  viewPath = "/DesignSystem/Info",
  size = "medium",
  marginTop = 0,
  marginBottom = 0,
  marginRight = 0,
  marginLeft = 0,
  text = "Info",
  textAlign = "left",
  width = "auto",
  maxWidth = "auto",
  lineHeight = 1.2,
  textOverflow = "ellipsis",
  whiteSpace = "nowrap",
  overflowX = "hidden",
  hyphens = "none"
  
}) {
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginRight={marginRight}
 marginLeft={marginLeft}
 text={text}
 textAlign={textAlign}
 width={width}
 maxWidth={maxWidth}
 lineHeight={lineHeight}
 textOverflow={textOverflow}
 whiteSpace={whiteSpace}
 overflowX={overflowX}
 hyphens={hyphens}
/>
{children}
</React.Fragment>)
}